import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-all-comm-report',
  templateUrl: './all-comm-report.component.html',
  styleUrl: './all-comm-report.component.scss'
})
export class AllCommReportComponent {



  constructor(
      private dialogRef: MatDialogRef<AllCommReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
    }
  
  
  today: Date = new Date();
  
    startDate: any = '';
    endDate: any = '';
    repName = '';
    offRepName = '';
    advtName = '';
    reportType = '';
    issueDates: any;
    issueDates1: any;
    getpaiddata: any;
    paidcommTotal: number;
    comtotal: number;
    issue_name :any;
  
    
  
   ngOnInit(): void {
    debugger
  
  let repname: any = this.data['repName'];
  
      // Then check if it's not empty and convert to array
      if (repname != "") {
        repname = [repname]; // This puts the single value in an array
      }
  
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issue_date;
      this.issueDates1 = this.data['issue_date'];
      this.issue_name = this.data['issue_name'];
  
    // const req: any = {
    //  "rep_name":  this.repName,
    //   "start_date": this.startDate,
    //   "end_date": this.endDate,
    //   "off_rep_name": this.offRepName,
    //   "advt_name": this.data['name'],
    //   // // "issue_name" : this.advtName,
    //   // "issue_date": this.issueDates
    //   "issue_name": "",
    //   "issue_date": this.issueDates1
  
  
    // }
  
    const req: any = {
      "rep_name": repname,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.data['name'],
      // // "issue_name" : this.advtName,
      // "issue_date": this.issueDates
      "issue_name": this.issue_name,
      "issue_date": this.issueDates
  
    }
  
  // pending Commission 
      this.service.getAllCommData(req).subscribe((data: any) => {
        debugger
        console.log("Get Paid Comm", data)
        this.getpaiddata = data as any;
  
        this.paidcommTotal = 0;
        this.comtotal = 0;
        for (let data1 of this.getpaiddata) {
          for (let data2 of data1.rep_data) {
            this.paidcommTotal += parseInt(data2.rcv_amt) || 0;
            this.comtotal += parseInt(data2.com_amt) || 0;
          }
        }
  
      });
  
   
    }

      exportExcel(fileName: string): void {
      const elt = document.getElementById('print-section') as HTMLTableElement | null;
      if (!elt) {
        console.error('Element with ID "print-section" not found');
        return;
      }
    
      // Convert table to sheet with raw parsing to preserve formats
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(elt, { raw: true });
    
      // Manually convert invoice date cells (dd/mm/yyyy) into actual Excel dates
      Object.keys(ws).forEach((addr) => {
        if (!addr.startsWith('!')) {
          const cell = ws[addr];
          const v = cell.v;
          if (typeof v === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
            const [dd, mm, yyyy] = v.split('/').map(n => parseInt(n, 10));
            const date = new Date(yyyy, mm - 1, dd);
            date.setMilliseconds(0); // Prevent float rounding :contentReference[oaicite:1]{index=1}
    
            cell.t = 'd';
            cell.v = date;
            cell.z = 'dd/mm/yyyy';
          }
        }
      });
    
      // Create workbook and trigger download
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    }
  
    show = false;
printPage3() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
        console.error("Print section not found!");
        return;
    }
  
    const printContent = printSection.innerHTML;
  
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1500;
    const leftPosition = screenWidth - windowWidth - 50;
  
    const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);
  
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A3 landscape;
                                margin: 3mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 10px !important;
                                color: #000 !important; /* Ensure dark text */
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: 100% !important;
                                border-collapse: collapse !important;
                                border-spacing: 0 !important;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 2px solid #000 !important;
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 3px 5px !important;
                                border: 1px solid #000 !important;
                                font-size: 10px !important;
                                line-height: 1.3;
                                word-wrap: break-word;
                                overflow-wrap: break-word;
                                color: #000 !important;
                            }
                            th {
                                background-color: #f2f2f2 !important;
                                font-weight: bold !important;
                                border-bottom: 2px solid #000 !important;
                            }
                            tr {
                                border-bottom: 1px solid #000 !important;
                            }
                            tr.header-row {
                                display: table-header-group !important;
                            }
                            td:nth-child(1) {
                                width: 1%;
                                text-align: left !important;
                                border-left: 1px solid #000 !important;
                            }
                            td:nth-child(2),
                            td:nth-child(3),
                            td:nth-child(4),
                            td:nth-child(5),
                            td:nth-child(6),
                            td:nth-child(8) {
                                text-align: left !important;
                            }
                            td:nth-child(5) {
                                width: 5%;
                                white-space: normal;
                            }
                            td.advt-name {
                                max-width: 160px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            td:nth-child(n+12),
                            td.amount,
                            td[data-type="number"] {
                                text-align: right !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 2px solid #000 !important; }
                            .br-rightt { border-right: 4px solid #000 !important; }
                            .br-bottom { border-bottom: 2px solid #000 !important; }
                            .br-top { border-top: 2px solid #000 !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 2px;
                                background-color: #000;
                                border-top: 2px solid #000 !important;
                            }
                            thead { 
                                display: table-header-group !important; 
                                border-bottom: 2px solid #000 !important;
                            }
                            tfoot { 
                                display: table-footer-group !important; 
                                border-top: 2px solid #000 !important;
                            }
                            td.balance-value {
                                text-align: right !important;
                                font-weight: bold !important;
                            }
                            /* Force all borders to be visible and dark */
                            table *, table *:before, table *:after {
                                border-color: #000 !important;
                                border-style: solid !important;
                                border-width: 1px !important;
                            }
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                            /* Ensure table headers are bold and dark */
                            th {
                                font-weight: bold !important;
                                color: #000 !important;
                            }
                            /* Force print background colors */
                            * {
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                        }
                        
                        /* Screen styles (preview) */
                        @media screen {
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 20px;
                                font-size: 10px;
                                color: #000;
                            }
                            table {
                                border: 2px solid #000;
                            }
                            th, td {
                                border: 1px solid #000;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                        window.onload = function() {
                            const table = document.querySelector('table');
                            if (!table) {
                                console.error("Table not found");
                                return;
                            }
                            
                            // Apply borders forcefully to all cells
                            const allCells = document.querySelectorAll('th, td');
                            allCells.forEach(cell => {
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            // Find and process header row
                            let headerRowIndex = -1;
                            const maxRowsToCheck = Math.min(10, table.rows.length);
                            
                            for (let i = 0; i < maxRowsToCheck; i++) {
                                const row = table.rows[i];
                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
                                
                                if (row.cells.length >= 8 &&
                                    (cellTexts.includes('Invoice No') ||
                                     cellTexts.includes('Receipt No') ||
                                     cellTexts.includes('Balance'))) {
                                    headerRowIndex = i;
                                    break;
                                }
                            }
                            
                            if (headerRowIndex >= 0) {
                                let thead = table.querySelector('thead');
                                if (!thead) {
                                    thead = document.createElement('thead');
                                    table.insertBefore(thead, table.firstChild);
                                }
                                
                                const headerRow = table.rows[headerRowIndex];
                                thead.appendChild(headerRow.cloneNode(true));
                            }
                            
                            // Alignment processing
                            const cells = document.querySelectorAll('td');
                            cells.forEach(cell => {
                                const content = cell.textContent.trim();
                                
                                if (content.includes('येणे') ||
                                    content.includes('Opening Balance') ||
                                    content.match(/^\\d+\\s+येणे$/) ||
                                    content.includes('Balance C/F') ||
                                    content.includes('Total')) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('balance-value');
                                }
                                
                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('amount');
                                }
                                
                                // Force borders and dark text
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            setTimeout(() => {
                                window.print();
                                setTimeout(() => { window.close(); }, 500);
                            }, 500); // Increased delay for better rendering
                        };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}

}
